// import React, { useEffect, useState } from 'react';
// import { Form, Formik } from 'formik';
// import * as Yup from 'yup';
// import { Button, TextField, ImageUploadWithPreview } from 'src/components';
// import Service from 'src/setup/network';
// import { toastAlert } from 'src/utils/toastAlert';
// import { shallowEqual, useSelector } from 'react-redux';
// import { useDispatch } from 'react-redux';
// import { RootState } from 'src/redux/reducers';
// import { IoIosClose } from 'react-icons/io';
// import { fetchDetails } from 'src/redux/action/details.action';
// import Card from 'src/components/card';
// import { BsCheckCircleFill } from 'react-icons/bs';

// interface IProps {
//   allowedOrderTypes?: any;
// }
// export const orderTypesData = [
//   {
//     id: 0,
//     value: 'dine_in',
//     title: 'Dine In',
//     path: '/public/dinein.svg',
//   },
//   {
//     id: 1,
//     value: 'takeway',
//     title: 'Takeway',
//     path: '/public/takeway.svg',
//   },
//   {
//     id: 2,
//     value: 'delivery',
//     title: 'Delivery',
//     path: '/public/delivery.svg',
//   },
// ];

// const FORM_VALIDATION = Yup.object().shape({});

// const OrderTypes: React.FC<IProps> = ({ allowedOrderTypes }) => {
//   const [isSelected, setIsSelected] = useState(false);
//   const [selectedOrderType, setSelectedOrderType] = useState<any>(null);
//   const dispatch = useDispatch();

//   const initValues = {
//     delivery: selectedOrderType?.title == 'Delivery' ? true : false,
//     dine_in: selectedOrderType?.title == 'Dine In' ? true : false,
//     takeaway: selectedOrderType?.title == 'Takeway' ? true : false,
//     online_order: false,
//   };

//   const handleSubmit = async (values: any, { resetForm }: any) => {
//     const payload = {
//       allowedOrderTypes: {
//         delivery: selectedOrderType?.title == 'Delivery' ? true : false,
//         dine_in: selectedOrderType?.title == 'Dine In' ? true : false,
//         takeaway: selectedOrderType?.title == 'Takeway' ? true : false,
//         online_order: false,
//       },
//     };
//     try {
//       await Service.post('/settings/update', payload);
//       toastAlert('success', `Order types is successfully edited`);
//       // resetForm();
//       dispatch(fetchDetails() as any);
//     } catch (err: any) {
//       toastAlert('error', err?.response?.data?.message);
//     }
//   };

//   const handleImageClick = (data: any) => {
//     const selectedOrderTypes = orderTypesData.find((el) => el?.id === data?.id);
//     setIsSelected(true);
//     setSelectedOrderType(selectedOrderTypes);
//   };

//   return (
//     <Formik
//       initialValues={initValues}
//       validateOnMount
//       onSubmit={handleSubmit}
//       validationSchema={FORM_VALIDATION}
//     >
//       {({ isSubmitting, isValid }) => (
//         <Form>
//           <div className="flex space-x-6 mb-6 ]">
//             {orderTypesData.map((el) => {
//               return (
//                 <>
//                   <div
//                     // name={el?.value}
//                     key={el?.id}
//                     onClick={() => handleImageClick(el)}
//                   >
//                     <Card
//                       className={`${
//                         isSelected && selectedOrderType?.id === el?.id
//                           ? 'border-[2px] rounded-xl border-primary w-[140px] h-[155px] cursor-pointer'
//                           : ''
//                       }w-[140px] h-[155px] cursor-pointer`}
//                     >
//                       <img src={el?.path} alt="" />
//                       <p className="text-center mt-4">{el?.title}</p>
//                     </Card>
//                   </div>
//                 </>
//               );
//             })}
//           </div>

//           <div className="flex items-center justify-end">
//             <Button
//               text="save details"
//               variant="primary"
//               type="submit"
//               isSubmitting={isSubmitting}
//               isValid={isValid}
//             />
//           </div>
//         </Form>
//       )}
//     </Formik>
//   );
// };

// export default React.memo(OrderTypes);

import React, { useEffect, useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Button, TextField, ImageUploadWithPreview } from 'src/components';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import WorkingDays from 'src/components/WorkingDays';
import { useDispatch } from 'react-redux';
import { fetchDetails } from 'src/redux/action/details.action';
import Card from 'src/components/card';
import { BsCheckCircleFill } from 'react-icons/bs';
import Loader from 'src/components/loader';
import { Delivery, DineIn, Takeway } from 'src/assets/images';

interface IProps {
  allowedOrderTypes?: any;
  loading?: boolean;
}

export const orderTypesData = [
  {
    id: 0,
    value: 'dine_in',
    title: 'Dine In',
    path: DineIn,
  },
  {
    id: 1,
    value: 'takeaway',
    title: 'Takeaway',
    path: Takeway,
  },
  {
    id: 2,
    value: 'delivery',
    title: 'Delivery',
    path: Delivery,
  },
];

const FORM_VALIDATION = Yup.object().shape({});

const OrderTypes: React.FC<IProps> = ({ allowedOrderTypes, loading }) => {
  const dispatch = useDispatch();

  //   const [selectedOrderTypes, setSelectedOrderTypes] = useState<string[]>(
  //     allowedOrderTypes
  //       ? orderTypesData
  //           .filter((orderType) => allowedOrderTypes[orderType.value])
  //           .map((orderType) => {
  //             if (
  //               orderType.value === 'delivery' &&
  //               allowedOrderTypes[orderType.value]
  //             ) {
  //               return orderType.value;
  //             }
  //             return '';
  //           })
  //       : []
  //   );
  const [selectedOrderTypes, setSelectedOrderTypes] = useState<string[]>(
    allowedOrderTypes
      ? Object.keys(allowedOrderTypes).filter((key) => allowedOrderTypes[key])
      : []
  );
  const initValues = {
    selectedOrderTypes: selectedOrderTypes,
  };
  const handleImageClick = (data: any) => {
    const orderType = data?.value;

    if (selectedOrderTypes.includes(orderType)) {
      setSelectedOrderTypes((prevSelectedTypes) =>
        prevSelectedTypes.filter((type) => type !== orderType)
      );
    } else {
      setSelectedOrderTypes((prevSelectedTypes) => [
        ...prevSelectedTypes,
        orderType,
      ]);
    }
  };

  const handleSubmit = async (values: any, { resetForm }: any) => {
    const payload = {
      allowedOrderTypes: {
        delivery: selectedOrderTypes?.includes('delivery') ? true : false,
        dine_in: selectedOrderTypes?.includes('dine_in') ? true : false,
        takeaway: selectedOrderTypes?.includes('takeaway') ? true : false,
        online_order: false,
      },
    };
    try {
      await Service.post('/settings/update', payload);
      toastAlert('success', `Order types are successfully updated`);
      dispatch(fetchDetails() as any);
    } catch (err: any) {
      toastAlert('error', err?.response?.data?.message);
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Formik
          initialValues={initValues}
          validateOnMount
          onSubmit={handleSubmit}
          validationSchema={FORM_VALIDATION}
        >
          {({ isSubmitting, isValid }) => (
            <Form>
              <div className="flex space-x-6 mb-6">
                {orderTypesData.map((el) => (
                  <div key={el?.id} onClick={() => handleImageClick(el)}>
                    <Card
                      className={`${
                        selectedOrderTypes.includes(el?.value)
                          ? 'border-[2px] rounded-xl border-primary w-[140px] h-[155px] cursor-pointer'
                          : ''
                      } w-[140px] h-[155px] cursor-pointer`}
                    >
                      <img src={el?.path} alt="" />
                      <p className="text-center mt-4">{el?.title}</p>
                    </Card>
                  </div>
                ))}
              </div>
              <div className="flex items-center justify-end">
                <Button
                  text="Save Details"
                  variant="primary"
                  type="submit"
                  isSubmitting={isSubmitting}
                  isValid={isValid}
                />
              </div>
            </Form>
          )}
        </Formik>
      )}
    </>
  );
};

export default React.memo(OrderTypes);
